var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({class:[
    'base-button',
    'font-extrabold py-3 px-4 transition duration-300 ease-in-out',
    _vm.variant,
    { outlined: _vm.outlined, rounded: _vm.rounded } ],attrs:{"disabled":_vm.disabled}},'button',_vm.$attrs,false),_vm.$listeners),[(_vm.loading)?_c('base-icon',{attrs:{"icon":"fa-circle-notch fa-spin","size":"fa-lg"}}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }